import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Text from 'Components/ComponentLibrary/Atoms/Text';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import DateRangeSection
  from 'Components/ComponentLibrary/Organisms/AccountPerformanceCommentaryCard/Sections/DateRangeSection';
import PerformanceChart
  from 'Components/ComponentLibrary/Organisms/AccountPerformanceCommentaryCard/Sections/PerformanceChart';
import useManagedAccountPageEventLogger
  from 'Views/Page/Content/Templates/ManagedAccountPageTemplate/managedAccountPage.eventLogging';

const styles = (theme) => ({
  root: { },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    rowGap: theme.spacing(1),
  },
  highlightedCommentary: {
    display: 'flex',
    columnGap: 5,
    paddingBottom: theme.spacing(1),
  },
  chart: {
    height: 75,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
});

const HighlightHeader = ({
  className,
  classes,
  label,
  chartData,
  startDate,
  endDate,
  onClickDateRange,
}) => {
  const { logCommentaryEvent } = useManagedAccountPageEventLogger();

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <Box className={classes.header}>
        <Text variant={'h6'} color={'black'} value={label} />
        <Box className={classes.highlightedCommentary} onClick={() => logCommentaryEvent('Highlighted Commentary Tag')}>
          <CheckCircleIcon color={'primary'} fontSize={'small'} />
          <Text variant={'h6'} value={'Highlighted Commentary'} />
        </Box>
      </Box>

      <PerformanceChart label={label} chartData={chartData} className={classes.chart} />

      <DateRangeSection startDate={startDate} endDate={endDate} onClickDateRange={onClickDateRange} />
    </Box>
  );
};

HighlightHeader.defaultProps = {
  className: '',
  chartData: undefined,
  onClickDateRange: undefined,
};

HighlightHeader.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  chartData: PropTypes.array,
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
  onClickDateRange: PropTypes.func,
};

export default withStyles(styles)(HighlightHeader);
